import { useTranslation } from 'next-i18next'

// hooks
import { getSpacePrice } from 'lib/getSpacePrice'

import styles from './PlanCard.module.scss'

interface Props {
  countryCode: string
  title: string
  iconImage: string
  description: string
  sizeType: string
  price?: string
}

export default function PlanCard({
  title,
  countryCode,
  iconImage,
  description,
  sizeType,
  price,
}: Props) {
  const { t } = useTranslation()

  return (
    <div className={styles.planCard}>
      <img className={styles.planCardImage} src={iconImage} alt={title} />
      <dl className={styles.planCardInfo}>
        <dt className={styles.planCardInfoTitle}>{title}</dt>
        <dd className={styles.planCardInfoPrice}>
          <strong className={styles.planCardInfoPriceAmount}>
            {price ? <>{price}</> : getSpacePrice(countryCode, sizeType)}
          </strong>
          <small className={styles.planCardInfoPriceDay}>
            /{t('AREAS.CITY.SLUG.PLAN_PRICE_DAY')}
          </small>
        </dd>
        <dd className={styles.planCardInfoDescription}>{description}</dd>
      </dl>
    </div>
  )
}
